/* eslint-disable no-underscore-dangle */
const _ = require('lodash');
require('./infiniteScroll.scss');

const deps = [require('vendor/lodash').name, require('ui/web/loadingSpinner').name];

const infiniteScrollDirective = $timeout => ({
  restrict: 'E',
  scope: {
    loadMore: '&', // function that returns a promise
  },
  template: '<bl-loading-spinner></bl-loading-spinner>',
  link($scope, $element) {
    const scrollElement = $element[0].parentNode;
    const scroll = angular.element(scrollElement);
    let isLoading = false;
    let diff = 0;

    // If this is called during digest, it should maintain scroll position with
    // infinite loading upwards. It is a little glitchy but overall works for now.
    const maintainScrollPos = () => {
      // TODO : HACKY: DONT-HACK: TERRIBLE: this needs to be replaced as soon as possible.
      // This is aweful code that shouldn't exist, but it solves a glitch while scrolling.
      // There are still things happening after the first digest cycle so we need to defer
      // to the next one before we can expect a final scrollHeight. As a failsafe, we have
      // the timeout function below (but it is glitchy if used on it own).
      $scope.$$postDigest(() =>
        $scope.$$postDigest(() => {
          scrollElement.scrollTop = scrollElement.scrollHeight - diff;
        }),
      );

      $timeout(() => (scrollElement.scrollTop = scrollElement.scrollHeight - diff));
    };

    const onScroll = _.throttle(() => {
      diff = scrollElement.scrollHeight - scrollElement.scrollTop;
      // If we're within one screen height of the top, start loading more data
      if (!isLoading && scrollElement.scrollTop < scrollElement.clientHeight) {
        $scope.$apply(() => {
          isLoading = true;
          $scope
            .loadMore()
            .then(() => maintainScrollPos())
            .finally(() => (isLoading = false));
        });
      }
    }, 50);

    $timeout(() => scroll.on('scroll', onScroll), 2000);

    // When this element is removed (like with ng-if) we should clean it up.
    $scope.$on('$destroy', () => scroll.off('scroll', onScroll));
  },
});

module.exports = angular
  .module('bench.ui.infiniteScroll', deps)
  .directive('blInfiniteScroll', infiniteScrollDirective);
